(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonios"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('gravit-testimonials')) {

  customElements.define(
    'gravit-testimonials',

    class extends HTMLElement {


      connectedCallback() {

        if (this.isReady) return;

        this.isReady = true;



        /* =========================
           ELEMENTOS
        ========================= */

        this.viewport =
          this.querySelector(
            '[data-gravit-viewport]'
          );


        this.track =
          this.querySelector(
            '[data-gravit-track]'
          );


        this.firstGroup =
          this.querySelector(
            '[data-gravit-group]'
          );


        this.dialog =
          this.querySelector(
            '[data-gravit-dialog]'
          );


        this.dialogImage =
          this.querySelector(
            '[data-gravit-dialog-image]'
          );


        this.dialogCaption =
          this.querySelector(
            '[data-gravit-dialog-caption]'
          );



        /* =========================
           TESTIMONIOS
        ========================= */

        this.testimonialTriggers =

          Array.from(
            this.querySelectorAll(
              '.gravit-testimonials__group:first-of-type [data-gravit-open]'
            )
          )

          .filter(
            trigger =>
              !trigger.disabled &&
              trigger.dataset.src
          );


        this.currentTestimonialIndex =
          0;



        /* =========================
           PLACEHOLDER MODAL
        ========================= */

        if (this.dialog) {


          this.dialogPlaceholder =

            document.createComment(
              'gravit-testimonials-modal'
            );


          this.dialog.parentNode.insertBefore(
            this.dialogPlaceholder,
            this.dialog
          );



          /* =========================
             EVENTOS MODAL
          ========================= */

          this.dialog.addEventListener(
            'click',
            (event) => {


              const previous =

                event.target.closest(
                  '[data-gravit-prev]'
                );


              const next =

                event.target.closest(
                  '[data-gravit-next]'
                );


              const close =

                event.target.closest(
                  '[data-gravit-close]'
                );


              const backdrop =

                event.target.closest(
                  '[data-gravit-backdrop]'
                );



              if (previous) {

                this.showTestimonial(
                  this.currentTestimonialIndex - 1
                );

                return;

              }


              if (next) {

                this.showTestimonial(
                  this.currentTestimonialIndex + 1
                );

                return;

              }


              if (
                close ||
                backdrop
              ) {

                this.closeDialog();

              }

            }
          );

        }



        /* =========================
           SETTINGS
        ========================= */

        this.autoplay =
          this.dataset.autoplay === 'true';


        this.pauseOnHover =
          this.dataset.pauseHover === 'true';


        this.direction =

          this.dataset.direction === 'right'
            ? 1
            : -1;


        this.duration =

          Math.max(
            Number(
              this.dataset.duration
            ) || 42,
            1
          );



        /* =========================
           STATE
        ========================= */

        this.offset =
          0;


        this.groupWidth =
          0;


        this.isDragging =
          false;


        this.pointerIsDown =
          false;


        this.isHovering =
          false;


        this.modalOpen =
          false;


        this.dragStartX =
          0;


        this.dragStartOffset =
          0;


        this.lastPointerX =
          0;


        this.lastPointerTime =
          0;


        this.velocity =
          0;


        this.suppressClick =
          false;


        this.lastTrigger =
          null;


        this.lastFrame =
          performance.now();


        this.reduceMotion =

          window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches;



        /* =========================
           CLICK TARJETAS
        ========================= */

        this.addEventListener(
          'click',
          (event) => {


            const trigger =

              event.target.closest(
                '[data-gravit-open]'
              );


            if (!trigger) return;


            if (
              this.suppressClick
            ) {

              event.preventDefault();

              event.stopPropagation();

              return;

            }


            if (
              !trigger.disabled
            ) {

              this.openDialog(
                trigger
              );

            }

          }
        );



        /* =========================
           POINTER CARRUSEL
        ========================= */

        if (this.viewport) {


          this.viewport.addEventListener(
            'pointerdown',
            (event) =>
              this.startDrag(event)
          );


          this.viewport.addEventListener(
            'pointermove',
            (event) =>
              this.moveDrag(event)
          );


          this.viewport.addEventListener(
            'pointerup',
            (event) =>
              this.endDrag(event)
          );


          this.viewport.addEventListener(
            'pointercancel',
            (event) =>
              this.endDrag(event)
          );


          this.viewport.addEventListener(
            'dragstart',
            (event) =>
              event.preventDefault()
          );

        }



        /* =========================
           HOVER
        ========================= */

        if (
          this.pauseOnHover &&
          this.viewport
        ) {


          this.viewport.addEventListener(
            'mouseenter',
            () => {

              this.isHovering =
                true;

            }
          );


          this.viewport.addEventListener(
            'mouseleave',
            () => {

              this.isHovering =
                false;


              this.lastFrame =
                performance.now();

            }
          );

        }



        /* =========================
           TECLADO
        ========================= */

        this.handleKeydown =
          (event) => {


            if (
              !this.modalOpen
            ) return;


            if (
              event.key === 'Escape'
            ) {

              this.closeDialog();

            }


            if (
              event.key === 'ArrowLeft'
            ) {

              event.preventDefault();


              this.showTestimonial(
                this.currentTestimonialIndex - 1
              );

            }


            if (
              event.key === 'ArrowRight'
            ) {

              event.preventDefault();


              this.showTestimonial(
                this.currentTestimonialIndex + 1
              );

            }

          };


        document.addEventListener(
          'keydown',
          this.handleKeydown
        );



        /* =========================
           RESIZE
        ========================= */

        this.resizeObserver =

          new ResizeObserver(
            () =>
              this.refreshMeasurements()
          );


        if (
          this.firstGroup
        ) {

          this.resizeObserver.observe(
            this.firstGroup
          );

        }


        this.refreshMeasurements();



        /* =========================
           LOOP
        ========================= */

        this.animationFrame =

          requestAnimationFrame(
            (time) =>
              this.animate(time)
          );

      }



      /* =====================================================
         DISCONNECT
      ===================================================== */

      disconnectedCallback() {


        cancelAnimationFrame(
          this.animationFrame
        );


        this.resizeObserver
          ?.disconnect();


        document.removeEventListener(
          'keydown',
          this.handleKeydown
        );


        if (
          this.dialog &&
          this.dialog.parentNode ===
          document.body
        ) {

          this.dialog.remove();

        }


        document.documentElement
          .classList
          .remove(
            'gravit-testimonials-modal-open'
          );


        this.isReady =
          false;

      }



      /* =====================================================
         VARIABLES
      ===================================================== */

      syncModalVariables() {


        if (
          !this.dialog
        ) return;


        const styles =
          getComputedStyle(this);


        const variables = [

          '--gt-text',

          '--gt-muted',

          '--gt-overlay',

          '--gt-background',

          '--gt-card',

          '--gt-border'

        ];


        variables.forEach(
          (variable) => {


            const value =

              styles
                .getPropertyValue(
                  variable
                )
                .trim();


            if (value) {


              this.dialog
                .style
                .setProperty(
                  variable,
                  value
                );

            }

          }
        );

      }



      /* =====================================================
         MEASURE
      ===================================================== */

      refreshMeasurements() {


        if (
          !this.firstGroup ||
          !this.track
        ) return;


        this.groupWidth =

          this.firstGroup
            .getBoundingClientRect()
            .width;


        this.normalizeOffset();

        this.renderTrack();

      }



      normalizeOffset() {


        if (
          !this.groupWidth
        ) return;


        while (
          this.offset <=
          -this.groupWidth
        ) {

          this.offset +=
            this.groupWidth;

        }


        while (
          this.offset > 0
        ) {

          this.offset -=
            this.groupWidth;

        }

      }



      renderTrack() {


        if (
          !this.track
        ) return;


        this.track.style.transform =

          `translate3d(${this.offset}px, 0, 0)`;

      }



      /* =====================================================
         AUTOPLAY
      ===================================================== */

      animate(time) {


        const elapsed =

          Math.min(
            Math.max(
              time -
              this.lastFrame,
              0
            ),
            64
          );


        const canMove =

          !this.isDragging &&
          !this.pointerIsDown &&
          !this.modalOpen &&
          !this.reduceMotion;



        if (
          canMove &&
          Math.abs(
            this.velocity
          ) > .015
        ) {


          this.offset +=

            this.velocity *
            elapsed;


          this.velocity *=

            Math.pow(
              .92,
              elapsed / 16.67
            );


          this.normalizeOffset();

          this.renderTrack();

        }


        else if (

          canMove &&

          this.autoplay &&

          !this.isHovering &&

          this.groupWidth

        ) {


          const pixelsPerMillisecond =

            this.groupWidth /
            (
              this.duration *
              1000
            );


          this.offset +=

            this.direction *
            pixelsPerMillisecond *
            elapsed;


          this.normalizeOffset();

          this.renderTrack();

        }


        this.lastFrame =
          time;


        this.animationFrame =

          requestAnimationFrame(
            (nextTime) =>
              this.animate(
                nextTime
              )
          );

      }



      /* =====================================================
         DRAG START
      ===================================================== */

      startDrag(event) {


        if (
          !this.track ||
          !this.groupWidth
        ) return;


        if (
          event.pointerType === 'mouse' &&
          event.button !== 0
        ) return;


        this.pointerIsDown =
          true;


        this.isDragging =
          false;


        this.suppressClick =
          false;


        this.velocity =
          0;


        this.dragStartX =
          event.clientX;


        this.dragStartOffset =
          this.offset;


        this.lastPointerX =
          event.clientX;


        this.lastPointerTime =
          performance.now();

      }



      /* =====================================================
         DRAG MOVE
      ===================================================== */

      moveDrag(event) {


        if (
          !this.pointerIsDown
        ) return;


        const distance =

          event.clientX -
          this.dragStartX;


        if (

          !this.isDragging &&

          Math.abs(
            distance
          ) > 10

        ) {


          this.isDragging =
            true;


          this.suppressClick =
            true;


          this.viewport
            .classList
            .add(
              'is-dragging'
            );


          this.viewport
            .setPointerCapture?.(
              event.pointerId
            );

        }


        if (
          !this.isDragging
        ) return;


        this.offset =

          this.dragStartOffset +
          distance;


        this.normalizeOffset();

        this.renderTrack();


        const now =
          performance.now();


        const deltaTime =

          Math.max(
            now -
            this.lastPointerTime,
            1
          );


        const deltaX =

          event.clientX -
          this.lastPointerX;


        this.velocity =

          deltaX /
          deltaTime;


        this.lastPointerX =
          event.clientX;


        this.lastPointerTime =
          now;

      }



      /* =====================================================
         DRAG END
      ===================================================== */

      endDrag(event) {


        if (
          !this.pointerIsDown
        ) return;


        this.pointerIsDown =
          false;


        if (
          this.isDragging
        ) {


          this.isDragging =
            false;


          this.viewport
            .classList
            .remove(
              'is-dragging'
            );


          if (

            this.viewport
              .hasPointerCapture?.(
                event.pointerId
              )

          ) {


            this.viewport
              .releasePointerCapture(
                event.pointerId
              );

          }


          this.lastFrame =
            performance.now();


          window.setTimeout(
            () => {

              this.suppressClick =
                false;

            },
            180
          );

        }


        else {

          this.suppressClick =
            false;

        }

      }



      /* =====================================================
         ABRIR
      ===================================================== */

      openDialog(trigger) {


        if (

          !this.dialog ||

          !this.dialogImage ||

          !trigger.dataset.src

        ) return;


        this.lastTrigger =
          trigger;


        const index =

          this.testimonialTriggers
            ?.indexOf(
              trigger
            );


        if (
          index >= 0
        ) {

          this.currentTestimonialIndex =
            index;

        }


        this.dialogImage.src =
          trigger.dataset.src;


        this.dialogImage.alt =
          trigger.dataset.alt || '';


        const caption =
          trigger.dataset.caption || '';


        if (
          this.dialogCaption
        ) {


          this.dialogCaption.textContent =
            caption;


          this.dialogCaption.hidden =
            !caption;

        }


        this.modalOpen =
          true;


        this.velocity =
          0;


        this.syncModalVariables();


        if (
          this.dialog.parentNode !==
          document.body
        ) {


          document.body.appendChild(
            this.dialog
          );

        }


        this.dialog.hidden =
          false;


        document.documentElement
          .classList
          .add(
            'gravit-testimonials-modal-open'
          );


        this.updateNavigation();


        requestAnimationFrame(
          () => {


            this.dialog
              .classList
              .add(
                'is-opening'
              );


            requestAnimationFrame(
              () => {


                this.dialog
                  .classList
                  .remove(
                    'is-opening'
                  );


                this.dialog
                  .classList
                  .add(
                    'is-open'
                  );

              }
            );

          }
        );


        /*
         * Foco correcto según dispositivo
         */

        requestAnimationFrame(
          () => {


            const mobile =
              window.matchMedia(
                '(max-width: 749px)'
              ).matches;


            const selector =
              mobile
                ? '.gravit-testimonials__close--mobile'
                : '.gravit-testimonials__close--desktop';


            this.dialog
              .querySelector(
                selector
              )
              ?.focus();

          }
        );

      }



      /* =====================================================
         CAMBIAR TESTIMONIO
      ===================================================== */

      showTestimonial(index) {


        if (

          !this.testimonialTriggers ||

          !this.testimonialTriggers.length

        ) return;


        const total =
          this.testimonialTriggers.length;


        this.currentTestimonialIndex =

          (
            index % total +
            total
          ) % total;


        const trigger =

          this.testimonialTriggers[
            this.currentTestimonialIndex
          ];


        if (

          !trigger ||

          !trigger.dataset.src

        ) return;


        this.dialogImage
          .classList
          .add(
            'is-changing'
          );


        window.setTimeout(
          () => {


            this.dialogImage.src =
              trigger.dataset.src;


            this.dialogImage.alt =
              trigger.dataset.alt || '';


            const caption =
              trigger.dataset.caption || '';


            if (
              this.dialogCaption
            ) {


              this.dialogCaption.textContent =
                caption;


              this.dialogCaption.hidden =
                !caption;

            }



            const finishChange =
              () => {


                requestAnimationFrame(
                  () => {


                    this.dialogImage
                      .classList
                      .remove(
                        'is-changing'
                      );

                  }
                );

              };


            if (
              this.dialogImage.complete
            ) {


              finishChange();

            }


            else {


              this.dialogImage.onload =
                finishChange;

            }

          },
          180
        );

      }



      /* =====================================================
         NAV
      ===================================================== */

      updateNavigation() {


        if (
          !this.dialog
        ) return;


        const navButtons =

          this.dialog.querySelectorAll(
            '.gravit-testimonials__modal-nav'
          );


        const hide =

          this.testimonialTriggers.length <= 1;


        navButtons.forEach(
          button => {


            button.hidden =
              hide;

          }
        );

      }



      /* =====================================================
         CERRAR
      ===================================================== */

      closeDialog() {


        if (

          !this.dialog ||

          !this.modalOpen

        ) return;


        this.dialog
          .classList
          .remove(
            'is-open',
            'is-opening'
          );


        this.dialog
          .classList
          .add(
            'is-closing'
          );


        window.setTimeout(
          () => {


            this.dialog
              .classList
              .remove(
                'is-closing'
              );


            this.dialog.hidden =
              true;


            this.modalOpen =
              false;


            document.documentElement
              .classList
              .remove(
                'gravit-testimonials-modal-open'
              );


            if (

              this.dialogPlaceholder &&

              this.dialogPlaceholder
                .parentNode

            ) {


              this.dialogPlaceholder
                .parentNode
                .insertBefore(
                  this.dialog,
                  this.dialogPlaceholder
                    .nextSibling
                );

            }


            this.lastFrame =
              performance.now();


            this.lastTrigger
              ?.focus();

          },
          280
        );

      }

    }

  );

}


  } catch(e) { console.error(e); }
})();
})();
